<template>
  <div class="section">
    <div class="container">
      <Permissions :user-id="$route.params.translatorId">
        <h1 class="title">
          {{ $t("translatorAcc") }}
        </h1>
        <div class="subtitle is-5">
          <span v-if="translator"> {{ translator.firstName }} {{ translator.lastName }} </span>
        </div>
        <TranslatorTabs :translator="translator" />
      </Permissions>
    </div>
  </div>
</template>

<script>
import Permissions from "@/components/Permissions.vue";
import TranslatorTabs from "@/components/TranslatorTabs.vue";
import { db } from "@/firebase";

export default {
  name: "TranslatorDashboard",
  components: {
    Permissions,
    TranslatorTabs,
  },
  data() {
    return {
      translator: {},
    };
  },
  computed: {
    translatorId() {
      if (this.$store.getters.getCurrentUser) {
        return this.$store.getters.getCurrentUser.uid;
      }
      return null;
    },
  },
  watch: {
    translatorId(translatorId) {
      if (translatorId) {
        this.$bind("translator", db.collection("member_translators").doc(translatorId));
        this.translator = {};
      }
    },
    $route: {
      immediate: true,
      handler() {
        this.$bind("translator", db.collection("member_translators").doc(this.$route.params.translatorId));
        this.translator = {};
      },
    },
  },
};
</script>
